export enum PremiumStatus {
  PENDING = 'PENDING',
  PENDING_RENEWAL = 'PENDING_RENEWAL',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}
